<script lang="ts" setup>
    import { Input } from '@/components/ui/input';
    import { Search } from 'lucide-vue-next';
    import { useVModel } from '@vueuse/core';
    import { cn } from '@/lib/utils';
    import type { HTMLAttributes } from 'vue';
    import { computed } from 'vue';

    const props = withDefaults(
        defineProps<{
            defaultValue?: string | number;
            modelValue?: string | number;
            class?: HTMLAttributes['class'];
            placeholder?: string;
            type?: 'text' | 'number';
            disabled?: boolean;
        }>(),
        {
            type: 'text',
        },
    );

    const emits = defineEmits<{
        (e: 'update:modelValue', payload: string | number): void;
    }>();

    const value = computed({
        get: () => props.modelValue,
        set: (newValue: string | number) => {
            emits('update:modelValue', newValue);
        },
    });
</script>

<template>
    <div class="relative">
        <Input
            :class="cn('w-full pl-7.5', props.class)"
            v-model="value"
            :placeholder="props.placeholder"
            :type="props.type"
            :disabled="props.disabled"
        />
        <Search
            class="text-faded-foreground pointer-events-none absolute top-1/2 left-2 size-3.5 -translate-y-1/2"
        />
    </div>
</template>
